import { Row, RenderConfig, TextInput, NumberInput } from 'commons-ui';

export const FORM_FIELD_KEYS = {
	EMAIL: 'email',
	ZUPEE_USER_ID: 'uid',
	PHONE_NUMBER: 'phone'
};

export const FORM_FIELD_LABELS = {
	[FORM_FIELD_KEYS.EMAIL]: 'Email',
	[FORM_FIELD_KEYS.ZUPEE_USER_ID]: 'Zupee User Id',
	[FORM_FIELD_KEYS.PHONE_NUMBER]: 'Phone Number'
};

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.EMAIL]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.EMAIL)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.EMAIL])
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			overrides: { InputContainer: { style: () => ({ backgroundColor: 'white' }) } }
		}),
	[FORM_FIELD_KEYS.ZUPEE_USER_ID]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.ZUPEE_USER_ID)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.ZUPEE_USER_ID])
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			overrides: { InputContainer: { style: () => ({ backgroundColor: 'white' }) } }
		}),
	[FORM_FIELD_KEYS.PHONE_NUMBER]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.PHONE_NUMBER)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.PHONE_NUMBER])
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			overrides: { InputContainer: { style: () => ({ backgroundColor: 'white' }) } }
		})
};

export const FORM_LAYOUT_CONFIG = [
	new Row(FORM_FIELD_KEYS.ZUPEE_USER_ID),
	new Row(FORM_FIELD_KEYS.PHONE_NUMBER),
	new Row(FORM_FIELD_KEYS.EMAIL)
];
